import styled from 'styled-components';
import { ReactNode } from 'react';
import Input from '@paradigm/design-system/src/components/Input';
import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import {
  useRfqFiltersFormActions,
  useRfqFiltersFormView,
} from '@paradigm/features/src/unified-rfqs/ui/rfq-filters/form-context';
import Tooltip from '@paradigm/design-system/src/components/Tooltip';
import { MOBILE_BREAKPOINT } from '@paradigm/design-system/src/units';
import RfqFilterForm from './RfqFilterForm';

export default function UnifiedRfqsFilterForm() {
  const { notional } = useRfqFiltersFormView();
  const { updateMinNotional, updateMaxNotional } = useRfqFiltersFormActions();

  return (
    <>
      <RfqFilterForm />
      <InputContainer>
        <NotionalInput
          label={
            <>
              RFQ Min Notional
              <Tooltip
                id="filter-min-notional-tooltip"
                tooltipContent={
                  <p>
                    Select RFQs in which the sum of all legs quantities in USD
                    is greater than or equal to the minimum value.
                  </p>
                }
              />
            </>
          }
          value={notional.min}
          onChange={updateMinNotional}
        />
        <NotionalInput
          label={
            <>
              RFQ Max Notional
              <Tooltip
                id="filter-max-notional-tooltip"
                tooltipContent={
                  <p>
                    Select RFQs in which the sum of all legs quantities in USD
                    is less than or equal to the maximum value.
                  </p>
                }
              />
            </>
          }
          value={notional.max}
          onChange={updateMaxNotional}
        />
      </InputContainer>
    </>
  );
}

function NotionalInput({
  label,
  value,
  onChange,
}: {
  label: ReactNode;
  value: string;
  onChange: (value: string) => void;
}) {
  const isMobile = useIsMobile();

  return (
    <Input
      label={<Label>{label}</Label>}
      inputType="numeric"
      size={isMobile ? 'large' : 'medium'}
      decimalScale={0}
      wrapperCss="height: 38px; border-radius: 4px; background-color: #23374E;"
      css="flex: 1;"
      allowLeadingZeros
      value={value}
      inputMode="decimal"
      thousandSeparator
      suffix="USD"
      onValueChange={({ value: updatedValue }) => {
        onChange(updatedValue);
      }}
    />
  );
}

const Label = styled.div`
  opacity: 1;
  color: white;
  font-size: 0.8125rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const InputContainer = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 1rem;
  margin-top: 1rem;
  width: 100%;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    flex-direction: column;
  }
`;
